module.exports = __webpack_public_path__ + "assets/img/mini.210928fb.png";